import Workouts from './Workouts';

export default Workouts;
